// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"47e2e0fa","487":"1d05196c","895":"8ea51c2e","934":"d2f7b80f"}[chunkId] + ".chunk.js";
};